import React, { ReactElement } from 'react';
import FormHelperText, { FormHelperTextProps, FormHelperTextTypeMap } from '@material-ui/core/FormHelperText';
import { Uds } from '../../types';

export type HelperTextProps<D extends React.ElementType = FormHelperTextTypeMap['defaultComponent'], P = {}> = Uds<
  FormHelperTextProps<D, P>
>;

export const HelperText = <D extends React.ElementType = FormHelperTextTypeMap['defaultComponent'], P = {}>({
  error,
  id,
  dataTest,
  children,
  ...rest
}: HelperTextProps<D, P>): ReactElement => (
  <FormHelperText error={!!error} data-test={dataTest} id={id ?? dataTest} {...rest}>
    {children}
  </FormHelperText>
);

export const getHelperText = (
  error?: boolean,
  helperText?: string | React.ReactNode,
  errorText?: string | React.ReactNode
): string | React.ReactNode | undefined => {
  if (error) return errorText ?? helperText;
  return helperText;
};
